import { createSlice } from '@reduxjs/toolkit';
import { HttpMethod } from '../../../Asset/httpMethod';
import { startLoader, stopLoader } from '../../Slices/Utility/loaderSlice';
import { AlertPopup, errorPopup } from '../../../Asset/common';
import { fetchDataNew as DynamicDisp, addData as DynamicSave } from '../Transaction/DynamicSlice';

export const TableName = "ApiRcvData"

export const fetchData = (isMessage) => async (dispatch) => {
  dispatch(startLoader())
  let ObjJsonDet = {
    jsonObj1: [{}],
    SPName: "API_GetApiRcvData"
  };
  console.log("obj", ObjJsonDet);
  let res = await HttpMethod.post(`/SystemConfig/InsUpdDel/DynSpExAsyncDisp`, ObjJsonDet);
  if (res?.status === 200) {
    if (!(res.data.DynDisp) && isMessage) {
      errorPopup(res.data)
      dispatch(getData({ DynDisp: [] }));
    }
    else {
      dispatch(getData(await res.data));
    }
  }
  dispatch(stopLoader())
};

const constructDataJson = (data) => {
  let newData = {};
  for (let key in data) {
    newData[key.toLowerCase()] = data[key];
  }

  let dataJson = {};
  dataJson["jsonObj"] = [];
  dataJson["TableName"] = TableName;
  dataJson["jsonObj"].push(newData);
  return dataJson;
};

export const addData = (data) => async (dispatch) => {
  const res = await HttpMethod.post('/SystemConfig/InsUpdDel/DynSpAsyncExc', data);
  if (res?.status === 200) {
    AlertPopup.SuccessPopup(res.data)
    dispatch(fetchData());
  }
};

export const updateData = (data) => async (dispatch) => {
  dispatch(startLoader())
  const dataJson = constructDataJson(data);
  const res = await HttpMethod.post('/SystemConfig/InsUpdDel/Update', dataJson);
  if (res?.status === 200) {
    AlertPopup.SuccessPopup(res.data);
    dispatch(fetchData())
  }
  dispatch(stopLoader())
};

export const deleteData = (data) => async (dispatch) => {
  dispatch(startLoader())
  const dataJson = constructDataJson(data);
  const res = await HttpMethod.post('/SystemConfig/InsUpdDel/Delete', dataJson);
  if (res?.status === 200) {
    AlertPopup.SuccessPopup(res.data);
    dispatch(fetchData())
  }
  dispatch(stopLoader())
}

export const ApiRcvDataMastSlice = createSlice({
  name: 'ApiRcvDataMast',
  initialState: {},
  loading: false,
  reducers: {
    getData: (state, action) => {
      return action.payload;
    }
  },
});
export const { getData } = ApiRcvDataMastSlice.actions;
export default ApiRcvDataMastSlice.reducer;